import { useState } from 'react'

import { faClipboard, faClipboardCheck } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, Snackbar, TextField } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

type propTypes = {
  value: string
  label: string
  disabled?: boolean
}

export const CopyToClipboard = ({ value, label, disabled }: propTypes) => {
  const [copied, setCopied] = useState(false)

  const copyToClipboard = () => {
    if (value) {
      navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 3000)
    }
  }
  return (
    <>
      <TextField
        value={value}
        inputProps={{ readOnly: true }}
        fullWidth
        multiline
        maxRows={5}
        variant="outlined"
        color="primary"
        label={label}
        disabled={disabled}
        InputProps={{
          endAdornment: (
            <IconButton
              color="primary"
              disableFocusRipple={true}
              onClick={() => copyToClipboard()}
              aria-label="copy to clipboard"
            >
              {copied ? <FontAwesomeIcon icon={faClipboardCheck} /> : <FontAwesomeIcon icon={faClipboard} />}
            </IconButton>
          ),
        }}
      ></TextField>
      {copied && (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={copied}
        >
          <Alert
            severity="success"
            icon={<FontAwesomeIcon icon={faClipboardCheck} />}
          >
            Copied to clipboard
          </Alert>
        </Snackbar>
      )}
    </>
  )
}
